module.exports = __webpack_public_path__ + "static/media/heartbeat.33fb9c89.svg";